<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <introduction
      v-show="step == 'introduction'"
      endpoint="signalement-pratique-illegale"
      :estFormulairePublic="estFormulairePublic"
      @next-step="next"
    >
    </introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import IdentificationSignalee from "@/components/SignalementPratiqueIllegale/IdentificationSignalee.vue"
import IdentificationSignalant from "@/components/SignalementPratiqueIllegale/IdentificationSignalant.vue"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/signalement-pratique-illegale/",
      paramsName: "formulaire_signalementpi",
      estFormulairePublic: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identificationSignalee", code: "titre-etape-1", state: "" },
        { path: "identificationSignalant", code: "titre-etape-2", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    IdentificationSignalee,
    IdentificationSignalant,
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>